// extracted by mini-css-extract-plugin
module.exports = {"content":"Automation_content_-13vg","divider":"Automation_divider_1PUxp"};